import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationService } from '../../service/translation.service';
@Component({
  selector: 'app-success-modal-with-check',
  templateUrl: './success-modal-with-check.component.html',
  styleUrls: ['./success-modal-with-check.component.css']
})
export class SuccessModalWithCheckComponent {
constructor(public dialogRef: MatDialogRef<SuccessModalWithCheckComponent>, public translation: TranslationService) { }
 onClose() {
    this.dialogRef.close();
  }
}
